import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AssetService } from 'src/app/shared/services/asset.service';
import { InfoDialogComponent } from '../product-information/info-dialog/info-dialog.component';

@Component({
  selector: 'app-product-not-found',
  templateUrl: './product-not-found.component.html',
  styleUrls: ['./product-not-found.component.scss']
})
export class ProductNotFoundComponent implements OnInit {
  private assetNumber: string;
  private sub: any;
  public serial: boolean;
  public imei: boolean;
  public serialNumber: string;
  public imeiNumber: string;
  public serialOrImeiNumber: string = "";
  constructor(public dialog: MatDialog, private router: Router, private activatedRoute: ActivatedRoute,public assetService: AssetService) { }

  ngOnInit(): void {
    this.sub = this.activatedRoute.params.subscribe((params) => {
      this.assetNumber = params["serialNumber"];
    });
    this.imei = this.assetService.getImei();
    this.serial = this.assetService.getSerial();
  }

  public openInfoDialog() {
    const dialogRef = this.dialog.open(InfoDialogComponent, {
      width: "350px"
    });
  }

  public onSubmit(){
    this.router.navigate(["/request/" + this.assetNumber], {queryParams: {type: "inquiry"}});
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  public onSubmitSearch() { 
    this.assetService.setSerial(true);
    this.assetService.setImei(true);
    this.serial = true;
    this.imei = true;
       if(this.serialNumber){
         this.serialOrImeiNumber = this.serialNumber;
         
         this.assetService.getAssetBySerialNumber(this.serialOrImeiNumber).subscribe(data => {
          if(data != null){
            this.router.navigate(["/overview/" + this.serialOrImeiNumber]);
          } else if(this.imeiNumber){
            this.serialOrImeiNumber = this.imeiNumber;
            this.assetService.getAssetBySerialNumber(this.serialOrImeiNumber).subscribe(data => {
              if(data != null){
                this.router.navigate(["/overview/" + this.serialOrImeiNumber]);
              } else{
                this.router.navigate(["notfound/" + this.serialOrImeiNumber]);
              }
              
            }); 
          }
          else{
            this.router.navigate(["notfound/" + this.serialOrImeiNumber]);
          }
          
        }); 
       } else if(this.imeiNumber){
         this.serialOrImeiNumber = this.imeiNumber;
         
         this.assetService.getAssetBySerialNumber(this.serialOrImeiNumber).subscribe(data => {
          if(data != null){
            this.router.navigate(["/overview/" + this.serialOrImeiNumber]);
          } else{
            this.router.navigate(["notfound/" + this.serialOrImeiNumber]);
          }
          
        }); 
       };

       
      }
    
  

}
